import { Subscription } from 'rxjs/Rx';
import { environment } from '../../environments/environment';
export const resourceUrl = environment.ENV.resourceUrl;
export const CookieNames = {
  loginKey: 'tokenr',
  district: 'district',
  paperSetKey: 'paperSetKey',
  paperPartId: 'paperPartId',
  paperId: 'paperId',
  timestore: 'papertime',
  paperPartNumber: 'PartNumber',
  username: 'username',
  name: 'name',
  userobj: 'userobj',
  points: 'points',
  onlineExam: 'online-exam',
  loginType: 'logintype',
  userImage: 'userimage',
  paperSettitle: 'psettitle',
  paperSet: 'paperset',
  paperTitle: 'ptitle',
  paperSetPrice: 'pPrice',
  paperStartStatus: 'paperStartStatus',
  part1NumberOfQustions: 'part1Qustions',
  part2NumberOfQustions: 'part2Qustions',
  subjects: 'subjects',
  isRemoveCartItem: 'isRemoveCartItem',
  registrationFee: 'registrationFee',
  registrationCode: 'registrationCode',
  registrationToken: 'registrationToken',
  userPackageId: 'userPackageId',
  subscriptionPackage: 'SubscriptionPackage',
  PaymentModel: 'PaymentModel',
  subscriptionCount : 'paidSubscribeCount'
};

export const ConstValues = {
  timeout: 10000
};

export const Grades = [
  { key: "GRADE3" },
  { key: "GRADE4" },
  { key: "GRADE5" },
]

export const HeaderTypes = {
  contentType: 'Content-Type',
  authKey: 'Authorization',
  setid: 'setid',
  defaultHeaderValue: 'application/json',
  fileUploadHeaderValue: 'multipart/form-data',
  catagoryId: 'catagoryid',
  userId: 'userId',
  language: 'language'
};

export const Testomonials = [
  {
    image: '/assets/img/version_2/comment.svg',
    text: "ශිෂ්‍යත්ව විභාගය ජය ගන්න Grade5 මට ගොඩක් උපකාර වුණා.",
    name: "දේශාන් සුපුන්",
    school: "කුලියාපිටිය මධ්‍ය විද්‍යාලය"
  },
  {
    image: '/assets/img/version_2/comment.svg',
    text: "ශිෂ්‍යත්ව විභාගය ජය ගන්න Grade5 මට ගොඩක් උපකාර වුණා.",
    name: "දේශාන් සුපුන්",
    school: "කුලියාපිටිය මධ්‍ය විද්‍යාලය"
  },
  {
    image: '/assets/img/version_2/comment.svg',
    text: "ශිෂ්‍යත්ව විභාගය ජය ගන්න Grade5 මට ගොඩක් උපකාර වුණා.",
    name: "දේශාන් සුපුන්",
    school: "කුලියාපිටිය මධ්‍ය විද්‍යාලය"
  },
  {
    image: '/assets/img/version_2/comment.svg',
    text: "ශිෂ්‍යත්ව විභාගය ජය ගන්න Grade5 මට ගොඩක් උපකාර වුණා.",
    name: "දේශාන් සුපුන්",
    school: "කුලියාපිටිය මධ්‍ය විද්‍යාලය"
  },
  {
    image: '/assets/img/version_2/comment.svg',
    text: "ශිෂ්‍යත්ව විභාගය ජය ගන්න Grade5 මට ගොඩක් උපකාර වුණා.",
    name: "දේශාන් සුපුන්",
    school: "කුලියාපිටිය මධ්‍ය විද්‍යාලය"
  },
  {
    image: '/assets/img/version_2/comment.svg',
    text: "ශිෂ්‍යත්ව විභාගය ජය ගන්න Grade5 මට ගොඩක් උපකාර වුණා.",
    name: "දේශාන් සුපුන්",
    school: "කුලියාපිටිය මධ්‍ය විද්‍යාලය"
  }
];

export const AuthTypes = {
  FACEBOOK: "facebook",
  GOOGLE: "google",
  FACEBOOK_AUTH: "auth/facebook",
  GOOGLE_AUTH: "auth/google",
  tokenPrefix: "Bearer ",
  type: '_type',
  token: '_token',
  setid: 'setid',
  access_token: 'access_token',
  authenticate: 'authenticate',
  authenticatebytoken: 'authenticatebytoken',

  numberOfVideos: 6,
  youtubeAppToken: 'AIzaSyAAatID8kefBDrdLZZjeCpwopavsh5e8Fo',
  channelKey: 'UCNl0QdzRj9esO0Q3vzcTBDQ',

};

export const PaymentSteps = {
  cart: 1,
  billingDetails: 2,
  paymentOptions: 3
}

export const BasicRoutes = {
  loginRedirect: '',
  login: '/',
  adminRedirect: '/admin/papers',

  /**
   * Basic child routing in the home page
   */
  clientExams: '/home/exams',
  clientPaymentCode: '/home/exams?code=',
  clientHeaderExams: 'exams',
  clientReports: 'reports',
  clientActivity: 'activity',
  clientLessons: 'lessons',
  clientInstructions: 'instructions',
  clientPayment: 'payment',
  clientSettings: '/home/settings',
  clientIntError: 'home/err_internet',
  clientLandingPage: '/home',
  mypapers: '/home/exams/my-papers',
  revisionPapers: '/home/exams/revision',
  onlinePapers: '/home/exams/online',
  /**
   * Sub routing in home page
   */
  clientPapers: 'papers',
  clientPaperParts: 'parts',
  clientPapersPaper: 'paper',
  clientSummary: 'summary',
  clientReview: 'review',
  /**
   * basic routes in payment
   */
  checkout: '/home/pay/checkout',
  billingInfo: '/home/pay/billing-info',
  paymentOptions: '/home/pay/payment-options/',
  paymentOptionsMobile: '/home/pay/payment-options/access_token',
  /**
   * basic route for registration fee payment
   */
  registrationPayment: '/home/registration',
  registrationPaymentMobile: '/home/registration/registration-payment/',
  paymentMobile: '/home/pay/payment-options/payment/',

  //dialog routs
  subscriptionInfo: '/home/dialog-subscription-info',

  results: "/home/statistics/overall"
};

export const redirectionPoints = {
  billingInfo: 'BillingInfo',
  mypapers: 'Mypapers',
  freePaper: 'FreePaper',
  registration: 'registration',
  subscriptionInfo: 'subscriptionInfo',
  online: 'online'
};

export const QustionTypes = {
  q1: 'in_type_1',
  q2: 'in_type_2',
  q3: 'in_type_3',
  q4: 'in_type_4',
  q5: 'in_type_5',
  q6: 'in_type_6',
  q7: 'in_type_7',
  q8: 'in_type_8',
  q9: 'in_type_9',
  q10: 'in_type_10',
  q11: 'gr_type_1',
  q12: 'gr_type_2',
  q13: 'gr_type_3',
  q14: 'gr_type_4',
  q15: 'gr_type_5',
  q16: 'gr_type_6',
  q17: 'gr_type_7',
  q18: 'gr_type_8',
  q19: 'gr_type_9',
  q20: 'gr_type_10',
  q21: 'gr_type_11',
  q22: 'gr_type_12'
};

export const QustionStatus = {
  new: 'NEW',
  inprogress: 'INPROGRESS',
  compleate: 'COMPLETED',

  //Answering options
  ansNew: 'NEW',
  ansSkiped: 'SKIPED',
  ansCompleated: 'COMPLEATE',

  //Store back qustion
  backQustion: 'BackQustion',
  subQustionNumber: 'SubQustionNumber'
};

export const ImageOptions = {
  defaultImage: '59e5eff6d802b96b6f4f12a9'
};

export const CircleUIOptions = {
  fillColor: '#84ad05',
  trailColor: '#eee',
  trailWidth: 1,
  duration: 1400,
  easing: 'bounce',
  strokeWidth: 3,
  baseColor: '#ED6A5A',
  theme: 'stroke'
};

export const FileTypes = [
  'image/jpeg',
  'image/jpg',
  'image/png',
  'image/gif'];

export const SweetAlert = {
  confermBtnColour: '#3085d6',
  ignoreBtnColour: '#d33',
};

export const PaymentTypes = {
  VISA: "visa",
  EAZYCASH: "dialog",
  SAMPATH: 'sampath'
};

export const AnswersStatus = {
  yes: 'Yes',
  no: 'No',
  answerClasses: ['', '', '', '', '', '', '', '']
};

export const AlertMessages = {
  success: 'සාර්ථකයි!',
  error: 'වැරදියි!',
  successState: 'සාර්ථකයි',
  errorState: 'වැරදියි',
  selectCorrectAnswerMessage: 'Please select one of billow answers'
};

export const Time = {
  paperPart1: 45,
  paperPart2: 75,
  paper: 6,
  watitngTime: 6,
};

export const QustionNavigationStatus = {
  new: 'NEW',
  compleate: 'COMPLEATE',
  skiped: 'SKIPED',
};

export const TimeFormatter = {
  hour: 'h ',
  minute: 'm ',
  second: 's '
};

export const Status = {
  finish: 'finish',
  lock: 'LOCK',
};

export const PaperTypes = {
  revision: 'revision',
  online: 'online',
  termTest: 'term-test',
  myPapers: 'my-papers'
};
export const PaymentStatus = {
  PENDING: 'PENDING',
}

export const StatisticsTypes = {
  overall: {
    text: 'OVERALL',
    chartColor: "#333333"
  },
  papers: {
    text: 'PAPERS',
    chartColor: "#f0ac18"
  },
  termTest: {
    text: 'TERMTEST',
    chartColor: "#48b6fb"
  },
  online: {
    text: 'ONLINE_EXAM',
    chartColor: "#8bc34a"
  }
};

export const LanguageSelector = [
  { display: 'English', value: 'en' },
  { display: 'සිංහල', value: 'si' },
  { display: 'தமிழ்', value: 'tm' },
];

export const defaultLanguage = 'si';

export const ErrorCodes = {
  UNPROCESSABLE_ENTITY: {
    CODE: 422,
    MESSAGE: "Unprocessable Entity"
  },
  UNAUTHORIZED: {
    CODE: 401,
    MESSAGE: "Data Exist"
  },
  UNAUTHORIZEDCODE: {
    CODE: 4019,
    CODER: 4014
  },
  NO_USER_ACCONT: {
    CODE: 4017,
    MESSAGE: "NO_USER_ACCOUNT"
  },
  FACEBOOK_USER: {
    CODE: 4025,
    MESSAGE: "FACEBOOK_USER"
  }

};

export const PaymentModel = {
  Subscription: "SUBSCRIPTION",
  NonSubscription: "NONSUBSCRIPTION"
}

export const DynamicClasses = {
  resultBg: 'result-bg'
};

export const ErrorText = {
  999: "REGISTERUSER",
  1000: "ENTERTOLOGIN",
  4010: "UNAUTHORIZED_LOGIN",
  4011: "",
  4012: "",
  4013: "",
  4014: "TRING_TO_OPEN_LOCK_PAPER_SET",
  4017: "NO_USER_ACCOUNT",
  4016: "USER_EXIST",
  4018: "LOGIN_EMAIL_NOT_VERIFIED",
  4019: "TOKEN_EXPIRED",
  4020: "TRY_AGAIN",
  4021: "USER_EXIST",
  4025: "FACEBOOK_USER",
  4032: "PAYMENT_GETWAY_PROBLEM",
  4034: "THIS_MOBILE_NUMBER_NOT_VERIFIED_YET",
  4061: "PAIMENT_INVALIED",
  4062: "NO_MONEY",
  4063: "PAYMENT_ERROR",
  4064: "PAYMENT_NO_RESPONCE",
  4065: "UNEXPECTED_ISSUE_DETECTED",

  5010: "PIC_SIZE_LIMT",
  5011: "PIC_FORMAT"
};

export const OnlineStatus = {
  ONLINE: "ONLINE",
  NOTONLINE: "NOTONLINE",
  COMPLETE: 'COMPLETED',
  INPROGRESS: 'INPROGRESS',
  START: { title: 'START', discription: 'START' },
  START_SECOND: { title1: 'START_SECOND1', title2: 'START_SECOND2', discription: 'START' },
  SECONDNDSTART: { title: 'SECONDNDSTART', discription: 'SECONDNDSTART' },
  NOTSTART: { title: 'NOTSTART', discription: 'NOTSTART' },
  COMPLETE_RESULT: { title: 'COMPLETE_RESULT', discription: 'END' },
  NOT_COMPLETE_RESULTS: { title: 'NOT_COMPLETE_RESULTS', discription: 'RESULT' },
  AFTER_RESULTS: { title: 'AFTER_RESULTS', discription: 'RESULT' },
  CANTSTART: { title: 'CANTSTART', discription: 'CANTSTART' },
  NOTDONE: { title: 'NOTDONE', discription: 'NOTDONE' },
  ONLINE_NOTDONE: { title: 'ONLINE_NOTDONE', discription: 'NOTDONE' },
  CANBUY: { title: 'CANBUY', discription: 'CANBUY' },
  ONLINE_CANBUY: { title: 'ONLINE_CANBUY', discription: 'CANBUY' },
  CANTBUY: { title: 'CANTBUY', discription: 'CANTBUY' },
  BLOCK: { title: 'BLOCK', discription: '' }
}

export const AccessLevel = {
  paid: 'PAID',
  free: 'FREE',
  lock: 'LOCK',
  unlock: 'UNLOCK',
  new: 'NEW'
}

export const TransactionType = {
  // "transaction-notvalied" : { title : "SUCCESS_BUY_PAPER", text  :  "SUCCESS_BUY_PAPER_TEXT" },
  "transaction-expired": { title: "EXPIRE_BUY_PAPER", text: "EXPIRE_BUY_PAPER_TEXT" },
  "transaction-canceled": { title: "CANCEL_BUY_PAPER", text: "CANCEL_BUY_PAPER_TEXT" },
  "transaction-not-completed": { title: "CANCEL_BUY_PAPER", text: "NOT_COMPLED_BUY_PAPER_TEXT" },
  "transaction-notvalied": { title: "CANCEL_BUY_PAPER", text: "NOT_COMPLED_BUY_PAPER_TEXT" },
  "transaction-completed": { title: "SUCCESS_BUY_PAPER", text: "SUCCESS_BUY_PAPER" },
  "customer-wallet-is-not-active": { title: "CANCEL_BUY_PAPER", text: "CUSTOMER_VOLAT_NOT_VALIED" },
  "exceeds-minimum-transaction-per-day": { title: "CANCEL_BUY_PAPER", text: "EXCEED_DAILY_TRANSACTION" },
  "less-than-minimum-transaction-value": { title: "CANCEL_BUY_PAPER", text: "LESS_THAN_MAXIUMEM_TRANSACTION" },
  "wallet-is-not-customer-type": { title: "CANCEL_BUY_PAPER", text: "WALLERT_IS_NOT_CUSTOMER_TYPE" },
  "customer-wallet-is-not-found": { title: "CANCEL_BUY_PAPER", text: "CUSTOMER_VOLAT_NOT_VALIED" },
  "merchent-wallet-is-not-found": { title: "CANCEL_BUY_PAPER", text: "MERCHENT_WALTE_IS_NOT_ACTIVE" },
  "wallet-is-not-merchent-type": { title: "CANCEL_BUY_PAPER", text: "WALERT_IS_NOT_MERCHENT_TYPE" },
  "merchent-wallet-not-found": { title: "CANCEL_BUY_PAPER", text: "MERCHENT_WALTE_NOTFOUND" },
  "utility-wallet-is-not-active": { title: "CANCEL_BUY_PAPER", text: "UTILITY_WALTER_NOT_ACTIVE_YET" },
  "invalied-payee": { title: "CANCEL_BUY_PAPER", text: "INVALIED_PAYEE" },
  "invalied-utility-account-no": { title: "CANCEL_BUY_PAPER", text: "INVALIED_UTILITY_NUMBER" },
  "maximum-account-limit-exceeds": { title: "CANCEL_BUY_PAPER", text: "MAXIAMUM_ACCOUNT_LIMIT_EXEED" },
  "customer-doesnot-have-enough-credit": { title: "CANCEL_BUY_PAPER", text: "CUSTOMER_NOT_HAVE_ENOUGH_CREDIT" },
  "invalied-amount": { title: "CANCEL_BUY_PAPER", text: "INVALIED_AMOUNT" },
  "customer-maximum-per-day-transaction-limit-exceeds": { title: "CANCEL_BUY_PAPER", text: "CUSTOMER_LIMITED_TRANSACTION_EXCEED" },
  "this-will-exceed-minimum-transaction-limit": { title: "CANCEL_BUY_PAPER", text: "THIS_WILL_EXEED_MAXIUMEM_TRANSACTION_LIMIT" },
  "request-parameter-validation-failed": { title: "CANCEL_BUY_PAPER", text: "REQUIEST_PARAMETER_VALIDATION_FAILED" },
  "platform-failer": { title: "CANCEL_BUY_PAPER", text: "PLATFORM_FAILURE" },

  "bank-not-avilable": { title: "CANCEL_BUY_PAPER", text: "Bank not available" },
  "bank-not-found": { title: "CANCEL_BUY_PAPER", text: "Bank not found" },
  "connection-error": { title: "CANCEL_BUY_PAPER", text: "Connection error" },
  "system-error": { title: "CANCEL_BUY_PAPER", text: "System error" },
  "transaction-rejected": { title: "CANCEL_BUY_PAPER", text: "Transaction rejected" },
  "connect-acuireing-bank": { title: "CANCEL_BUY_PAPER", text: "Connect acquiring bank" },
  "no-response": { title: "CANCEL_BUY_PAPER", text: "No response" },
  "gateway-unavilable": { title: "CANCEL_BUY_PAPER", text: "Gateway unavilable" },
  "network-error": { title: "CANCEL_BUY_PAPER", text: "Network Error" },
  "cartridge-error": { title: "CANCEL_BUY_PAPER", text: "Cartridge error" },
  "server-busy": { title: "CANCEL_BUY_PAPER", text: "Server busy" },
  "various-messages": { title: "CANCEL_BUY_PAPER", text: "Transaction data failed validation. Check data mentioned in the response text and retry." },
  "timeout": { title: "CANCEL_BUY_PAPER", text: "A queued transaction timed out." },
  "account-error": { title: "CANCEL_BUY_PAPER", text: "The specified account is not available on the server." },
  "card-expired": { title: "CANCEL_BUY_PAPER", text: "A past date was set for card expiry date" },
  "invalied-expiry": { title: "CANCEL_BUY_PAPER", text: "An invalid card expiry date was specified." },
  "invalied-account": { title: "CANCEL_BUY_PAPER", text: "An invalid account was specified." },
  "invalied-card-number": { title: "CANCEL_BUY_PAPER", text: "Invalied card number" },
  "invalied-mode": { title: "CANCEL_BUY_PAPER", text: "An interface request specified an illegal value in \"Polled\" field." },
  "unable-to-process": { title: "CANCEL_BUY_PAPER", text: "An indeterminate error has occurred." },
  "over-transaction-limit": { title: "CANCEL_BUY_PAPER", text: "Over transaction limit." },
}

export const Gtype = {
  // isCard: false,
  // isDialog: false,
  // isMobitel: false,
  // isBillDialog: false,

  'DIALOG_BILL_PAYMENT': {
    true: {
      isBillDialog: true
    },
    false: {
      isBillDialog: false
    }
  }, 'EZCASH': {
    true: {
      isDialog: true
    },
    false: {
      isDialog: false
    }
  },
  'MCASH': {
    true: {
      isMobitel: true
    },
    false: {
      isMobitel: false
    }
  }, 'CARD_PAYMENT': {
    true: {
      isCard: true
    },
    false: {
      isCard: false
    }
  }, 'SAMPATH_VISHWA_PAYMENT': {
    true: {
      isVishwa: true
    },
    false: {
      isVishwa: false
    }
  }, 'LANKA_BELL_PAYMENT': {
    true: {
      isLankaBell: true
    },
    false: {
      isLankaBell: false
    }
  }
}

export const Regex = {
  email: '/^[a-zA-Z0-9._-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,6}$/'
}

export const SuccessText = {
  2010: "EMAIL_HAS_BEEN_SENT"
}

export const LoginTypes = {
  web: 'WEB',
  mobile: 'MOBILE'
}
export const Info = {
  mobile: '0777678700',
  mail: 'info@grade5.lk'
}

export const Pricing = {
  model: 'subscription'
  // pricingmodel : 'papers'
}

export class ApiEndpoints {
  static APP_URL = environment.ENV.clientAppUrl;
  static BASE_URL = environment.ENV.apiBaseUrl;
  static MOBILE_APP_URL = environment.ENV.androidAppName;
  static MOBILE_REDIRECT_URL: string = environment.ENV.mobileRedirectUrl;
  static YOUTUBE_BASE_URL = `https://www.youtube.com/embed/`;
  static users: string = `${ApiEndpoints.BASE_URL}users`;
  static authByToken: string = `${ApiEndpoints.BASE_URL}authenticatebytoken`;
  static authenticate: string = `${ApiEndpoints.BASE_URL}authenticate`;
  static authenticateViaMobile: string = `${ApiEndpoints.BASE_URL}authenticate/mobile`;
  static migrateEmailUsers: string = `${ApiEndpoints.BASE_URL}migrate-email-users`;
  static facebookAuth: string = `${ApiEndpoints.BASE_URL}${AuthTypes.FACEBOOK_AUTH}`;
  static googleAuth: string = `${ApiEndpoints.BASE_URL}${AuthTypes.GOOGLE_AUTH}`;
  static versions: string = `${ApiEndpoints.BASE_URL}versions`;
  static verifymobiletoken: string = `${ApiEndpoints.BASE_URL}verifymobiletoken`;
  static resendmobiletoken: string = `${ApiEndpoints.BASE_URL}resendmobiletoken`;
  static getPaymentCode: string = `${ApiEndpoints.BASE_URL}client/payment/`;

  // PaperSet endpoints
  static paperSets: string = `${ApiEndpoints.BASE_URL}client/papersets?page=1`;
  static paperSetStaticts: string = `${ApiEndpoints.BASE_URL}client/statics/papersets`;
  static verifyEmail: string = `${ApiEndpoints.BASE_URL}verify/`;
  static forgetPassword: string = `${ApiEndpoints.BASE_URL}forgetPassword/`;
  static getTokenAgain: string = `${ApiEndpoints.BASE_URL}sendVerifyEmail`;
  static paperSetReportStaticts: string = `${ApiEndpoints.BASE_URL}client/reports/statics/papersets`;
  static paperSetReports: string = `${ApiEndpoints.BASE_URL}client/reports/papersets?page=1`;
  static commingSoon: string = `${ApiEndpoints.BASE_URL}client/commingsoon`;
  static popularPaperSets: string = `${ApiEndpoints.BASE_URL}client/landing/papersets`;
  static getToBuyItemStatus: string = `${ApiEndpoints.BASE_URL}cart/avilability`;
  // Paper endpoints
  static paperStaticts: string = `${ApiEndpoints.BASE_URL}client/statics/papers`;

  // Exams
  static finalizeExam: string = `${ApiEndpoints.BASE_URL}client/finalize`;
  static answerToQuesion: string = `${ApiEndpoints.BASE_URL}client/answertoquestion`;

  static updateUser: string = `${ApiEndpoints.BASE_URL}users`;
  static districts: string = `${ApiEndpoints.BASE_URL}client/districts`
  static crash: string = `${ApiEndpoints.BASE_URL}crash`;
  static changeEmail: string = `${ApiEndpoints.BASE_URL}chnageemail`;
  static getPaperSummary: string = `${ApiEndpoints.BASE_URL}client/finalresult`;


  // params
  static pageNumber: string = 'pageNumber';
  static setid: string = 'setid';
  static paperid: string = 'paperid';
  static page: string = 'page';
  static partid: string = 'partid';
  static questionNumber: string = 'questionNumber';
  static questionNo: string = 'questionNo';
  static userid: string = 'userid';
  static invoiceId: string = 'invoiceId';
  static mobile: string = 'mobile';
  static price: string = 'price';
  static paperSetType = 'papersettype';
  static subjectCategoryid = "categoryid"
  static papers = 'papers';
  static registrationToken = 'registrationToken';
  static requestedPackageId = 'requestedPackageId';
  static action = 'action';

  static paperType: string = 'type';
  static paperTypeOnline = 'ONLINE_EXAM';
  static paperTypePapers = 'PAPERS';
  static paperTypeTermtest = 'TERMTEST';
  static paperTypeMyPapers = 'MY_PAPERS';
  static paperUserStatus: string = 'userStatus';
  static paperUserStatusAll: string = "ALL";
  static paperUserStatusNew: string = 'NEW';
  static paperUserStatusInProgress: string = 'INPROGRESS';
  static paperUserStatusComplited: string = 'COMPLETED';
  static students: string = 'students';
  static paperSetIds: string = 'paperSetIds';
  static statusPaperid: string = 'paperid';

  // user papers viwing type
  static questingViewingTypeExam = 'EXAM';
  static questingViewingTypeReport = 'REPORT';
  static paymentMethodsDialog = 'DIALOG';
  static paymentMethodsCoin = 'COIN';
  static paymentMethodsEzcash = 'EZCASH';
  static paymentMethodsSampath = 'SAMPATH_VISHWA';
  static paymentMethodsMcash = 'MCASH';
  static paymentMethodsCard = 'CARD';
  static paymentMethodsGrade5Coin = 'GRADE5_COIN';
  static paymentMethodsProvidor = "provider";
  static paymentcode: string = 'paymentcode';
  static isRegistrationFee: string = 'isRegistrationFee';
  static transactionCode: string = 'transactionCode';

  // tslint:disable-next-line:max-line-length
  static getPaperSets: string = `${ApiEndpoints.BASE_URL}client/papersets?type={${ApiEndpoints.paperType}}&page={${ApiEndpoints.pageNumber}}&userStatus={${ApiEndpoints.paperUserStatus}}`;
  static getOnlinePaperSets: string = `${ApiEndpoints.BASE_URL}client/online/papersets?type={${ApiEndpoints.paperType}}&page={${ApiEndpoints.pageNumber}}&userStatus={${ApiEndpoints.paperUserStatus}}`;
  static getPapers: string = `${ApiEndpoints.BASE_URL}client/papersets/{${ApiEndpoints.setid}}/papers?page={${ApiEndpoints.pageNumber}}`;
  static getPaper: string = `${ApiEndpoints.BASE_URL}client/papers/{${ApiEndpoints.paperid}}`;
  static getPaperChartData: string = `${ApiEndpoints.BASE_URL}client/history/{${ApiEndpoints.paperid}}`;
  static getPaperStatics: string = `${ApiEndpoints.BASE_URL}client/reports/statics/{${ApiEndpoints.paperid}}`;
  static getPaperReportStatics: string = `${ApiEndpoints.BASE_URL}client/reports/statics/papers/{${ApiEndpoints.setid}}`;
  static getPaperReports: string = `${ApiEndpoints.BASE_URL}client/reports/papersets/{${ApiEndpoints.setid}}/papers?page=1`;
  static getPaperParts: string = `${ApiEndpoints.BASE_URL}client/papers/{${ApiEndpoints.paperid}}`;
  static getPaperPartsStatics: string = `${ApiEndpoints.BASE_URL}client/statics/paperparts/{${ApiEndpoints.paperid}}`;
  static getQuestionByPaginate: string = `${ApiEndpoints.BASE_URL}client/question/{${ApiEndpoints.partid}}/{${ApiEndpoints.questionNumber}}`;
  static getOnGoingQuesion: string = `${ApiEndpoints.BASE_URL}client/ongoingquestion/{${ApiEndpoints.partid}}/{${ApiEndpoints.questionNumber}}`
  static getQuestionsReleventToSubject: string = `${ApiEndpoints.BASE_URL}client/questions/subjects/{${ApiEndpoints.partid}}`;
  static getQuestionAnswers: string = `${ApiEndpoints.BASE_URL}client/reports/questions/{${ApiEndpoints.partid}}/list`;
  static getQuestionById: string = `${ApiEndpoints.BASE_URL}client/reports/paperparts/{${ApiEndpoints.partid}}/questions/{${ApiEndpoints.questionNo}}`;
  static getSubjects: string = `${ApiEndpoints.BASE_URL}client/subjects/{${ApiEndpoints.partid}}`;
  static getUserById: string = `${ApiEndpoints.BASE_URL}users`;
  static getStaff: string = `${ApiEndpoints.BASE_URL}teachers`;
  static getPartners: string = `${ApiEndpoints.BASE_URL}aboutus`;
  static getwijayanews: string = `${ApiEndpoints.BASE_URL}wijayanews`;
  static getDistricts: string = `${ApiEndpoints.BASE_URL}districts`;
  static getPendingPapersToBuy: string = `${ApiEndpoints.BASE_URL}students/{${ApiEndpoints.students}}/papersets`;
  static getAllQuestionByPartID: string = `${ApiEndpoints.BASE_URL}questions/{${ApiEndpoints.partid}}?paginate=true`;

  // for statistics
  static getStatisticsOverAll: string = `${ApiEndpoints.BASE_URL}client/statistics/{${ApiEndpoints.paperSetType}}`;
  static getStatisticsOverAllSubjectByPaperType: string = `${ApiEndpoints.BASE_URL}client/statistics/{${ApiEndpoints.paperSetType}}/category/{${ApiEndpoints.subjectCategoryid}}`;
  static getStatisticsByPaperId: string = `${ApiEndpoints.BASE_URL}client/statistics/papers/{${ApiEndpoints.papers}}`;
  static getStatisticsByPaperIdCatId: string = `${ApiEndpoints.BASE_URL}client/statistics/papers/{${ApiEndpoints.statusPaperid}}/category/{${ApiEndpoints.subjectCategoryid}}`;
  // Payments
  static checkPayment: string = `${ApiEndpoints.BASE_URL}transaction?code=`;
  // static paymentReferenceCgetPaymentOfferode: string = `${ApiEndpoints.BASE_URL}client/papersets/generatepaymentcode`;
  static paymentReferenceCode: string = `${ApiEndpoints.BASE_URL}client/payment/generatepaymentcode`;
  static paymentmCash: string = `${ApiEndpoints.BASE_URL}payment/mcash`;
  static paymentezCash: string = `${ApiEndpoints.BASE_URL}payment/ezcash`;
  static sampathVisaToken: string = `${ApiEndpoints.BASE_URL}payment/sampath`;
  static discardChanges: string = `${ApiEndpoints.BASE_URL}client/questions/discardchanges`;
  static paymentMethods: string = `${ApiEndpoints.BASE_URL}payment/types`;
  static ezcashSubscribe: string = `${ApiEndpoints.BASE_URL}payment/dialog/subscribe`;
  static ezcashSubmitpin: string = `${ApiEndpoints.BASE_URL}payment/dialog/submitpin`;
  static sampathVisaPayment: string = `${ApiEndpoints.BASE_URL}payment/sampath/creditcardinfo`;
  static sampathVishwaPayment: string = `${ApiEndpoints.BASE_URL}payment/sampath/vishwa`;
  static coinAvailability: string = `${ApiEndpoints.BASE_URL}payment/coins/avilability`;
  static coinConfirem: string = `${ApiEndpoints.BASE_URL}payment/coins/confirm`;
  static offerImage: string = `${ApiEndpoints.BASE_URL}admin/latestoffers`;
  static getPaymentMobileAutenticate: string = `${ApiEndpoints.BASE_URL}client/mobile-payment/{${ApiEndpoints.paymentcode}}`;

  //registration fee
  static getRegistrationFee: string = `${ApiEndpoints.BASE_URL}admin/registration-fee`;
  static getRegistrationFeeGForUser: string = `${ApiEndpoints.BASE_URL}client/mobile-payment/{${ApiEndpoints.registrationToken}}`;

// get winners
static getTopTenWinners: string = `${ApiEndpoints.BASE_URL}users/leaderboard?limit=20`;
static getUserPerformances: string = `${ApiEndpoints.BASE_URL}users/leaderboard/{${ApiEndpoints.userid}}`;

  //Youtube
  static youtube: string = `https://www.googleapis.com/youtube/v3/search?key=${AuthTypes.youtubeAppToken}&channelId=${AuthTypes.channelKey}&part=snippet,id&order=date&maxResults=${AuthTypes.numberOfVideos}`;
  static tipList: string = 'https://www.googleapis.com/youtube/v3/playlistItems?part=snippet&playlistId=PLgZ52NGg0ua94d5vrA2qYo2mnf8RGOYTC&key=AIzaSyAAatID8kefBDrdLZZjeCpwopavsh5e8Fo&maxResults=50';
  static tutorialList: string = 'https://www.googleapis.com/youtube/v3/playlistItems?part=snippet&playlistId=PLgZ52NGg0ua9cVU1fl8ki_IzX1xj80w4b&key=AIzaSyAAatID8kefBDrdLZZjeCpwopavsh5e8Fo&maxResults=50';
  static adviceList: string = 'https://www.googleapis.com/youtube/v3/playlistItems?part=snippet&playlistId=PLgZ52NGg0ua_qAbmV8hWfjHAaGac8YV05&key=AIzaSyAAatID8kefBDrdLZZjeCpwopavsh5e8Fo&maxResults=50';
  static replaceParms = (url, params) => {
    let formattedUrl = url;
    let r = new RegExp('{(.*?)}', 'gi');
    let match;
    while ((match = r.exec(url)) != null) {
      formattedUrl = formattedUrl.replace(new RegExp(match[0], 'g'), params[match[1]])
    }
    return formattedUrl;
  }

  // dialog subscription
  static getSubscriptionPackages: string = `${ApiEndpoints.BASE_URL}dialogconcent/getpackages`;
  static checkUserSubscriptionStatus: string = `${ApiEndpoints.BASE_URL}user/status?mobile={${ApiEndpoints.mobile}}&requestedPackageId={${ApiEndpoints.requestedPackageId}}&action={${ApiEndpoints.action}}`;
  static checkUserSubscriptionValidity = `${ApiEndpoints.BASE_URL}user/status?mobile={${ApiEndpoints.mobile}}`;
  static liveExamToSubscribers = `${ApiEndpoints.BASE_URL}subscribe?mobile={${ApiEndpoints.mobile}}&requestedPackageId={${ApiEndpoints.requestedPackageId}}`;
  // Payment types
  static getPaymentTypes: string = `${ApiEndpoints.BASE_URL}getPaymentType`;

  //competition winners
  static getWinners = `${ApiEndpoints.BASE_URL}competition/users`;

}

export const tutorialVideo = {
  show : false,
  videoUrl: "https://www.youtube.com/embed/ilOm3V67hEU?rel=0",
  title:"Video 2 : පෙරහුරු ප්‍රශ්න පත්‍රය 02 - ගැටළු සාකච්ඡා කිරීම",
  imageUrl:"/assets/img/tutorialvideo.png"
};



// WEBPACK FOOTER //
// /usr/share/nginx/grade5_live/grade5-frontend-2.0/src/app/core-modules/constant.ts